import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Deze pagina melden',
  title: 'Een probleem met deze pagina melden',
  reasons: {
    'inaccurate-or-fabricated': 'Onjuiste of verzonnen informatie',
    'wrong-product': 'De producten passen niet bij de pagina',
    'sexually-explicit': 'Seksueel expliciete inhoud',
    'regulated-product': 'Receptplichtig of gereguleerd product',
    'dangerous-product': 'Gevaarlijk product',
    'ip-infringement': 'Schendt mijn rechten (merk/auteursrecht)',
    other: 'Iets anders',
  },
  detail: 'Toelichting (optioneel)',
  submit: 'Melding versturen',
  cancel: 'Annuleren',
  sent: 'Bedankt. We bekijken meldingen binnen 24 uur.',
  failed: 'De melding kon niet worden verstuurd. Probeer het opnieuw.',
};
